import {z} from 'zod';
import {zNumberToString} from '@brunata-angular/util';

export const buildingInfoSchema = z
    .object({
        postalCode: z.string().nullable(),
        buildingName: z.string().nullable(),
        countryCode: z.string(),
        city: z.string().nullable(),
        buildingNo: zNumberToString,
        address2: z.string().nullable(),
        address1: z.string().nullable(),
        brunataBranch: zNumberToString,
    })
    .transform(it => ({
        ...it,
        branchInDk:
            it.brunataBranch !== null ? ['10', '11', '12', '99'].includes(it.brunataBranch) : false,
    }));
